import { CalculatorIcon, DocumentTextIcon } from '@heroicons/vue/solid'
import { i18n } from '../../../../localization'
import { computed, ComputedRef, ConcreteComponent, RenderFunction } from 'vue'
import { App } from '../../../../typings/api-enums'
import { EcspComplianceProfile } from '../../../../utilities/account/useAccountDataPersonal'
import InvestorClassificationForm from '../../../wizard/ECSP/form/InvestorClassificationForm.vue'
import ExperienceForm from '../../../wizard/ECSP/form/ExperienceForm.vue'
import RiskForm from '../../../wizard/ECSP/form/RiskForm.vue'
import InvestmentGoalsForm from '../../../wizard/ECSP/form/InvestmentGoalsForm.vue'
import FinancialSituationForm from '../../../wizard/ECSP/form/FinancialSituationForm.vue'
import {
    showNotEnoughExperienceWarning,
    showNotEnoughInvestorClassificationWarning,
    showNotEnoughRiskAcknowledgementsWarning,
} from '../../../../utilities/account/useEcspRegulatory'

export const ecspPersonalComplianceProfileConfig: EcspPersonalComplianceProfileConfig = {
    'Investor Classification': {
        component: InvestorClassificationForm,
        icon: DocumentTextIcon,
        title: i18n.global.t('account_settings.investor_classification'),
        validationKey: 'investor_classification',
        denyKey: `investor_classification.expert_investor_treatment,${App.Enums.ComplianceProfile.YesNoOption.NO}`,
        showsWarning: computed(() => showNotEnoughInvestorClassificationWarning()),
        clearValuesOnClose: true,
    },
    'Experience': {
        component: ExperienceForm,
        icon: DocumentTextIcon,
        title: i18n.global.t('account_settings.experience'),
        validationKey: 'experience',
        denyKey: 'experience.no_answer',
        showsWarning: computed(() => showNotEnoughExperienceWarning()),
        clearValuesOnClose: true,
    },
    'Risk': {
        component: RiskForm,
        icon: DocumentTextIcon,
        title: i18n.global.t('account_settings.risk'),
        validationKey: 'risk',
        denyKey: 'risk.no_answer',
        showsWarning: computed(() => showNotEnoughRiskAcknowledgementsWarning()),
        clearValuesOnClose: true,
    },
    'Investment Goals': {
        component: InvestmentGoalsForm,
        icon: DocumentTextIcon,
        title: i18n.global.t('account_settings.investment_goals'),
        validationKey: 'investment_goals',
        denyKey: 'investment_goals.no_answer',
        clearValuesOnClose: true,
    },
    'Financial Situation': {
        component: FinancialSituationForm,
        icon: CalculatorIcon,
        title: i18n.global.t('account_settings.financial_situation'),
        buttonTitle: i18n.global.t('ecsp.financial_situation.calculate'),
        validationKey: 'financial_situation',
        hideStatus: true,
        clearValuesOnClose: true,
        requireConfirm: true,
    },
}

export interface EcspPersonalComplianceProfileConfig {
    [key: string]: {
        component: ConcreteComponent
        icon: RenderFunction | ConcreteComponent
        title: string
        buttonTitle?: string
        validationKey: keyof EcspComplianceProfile
        denyKey?: string
        showsWarning?: ComputedRef<boolean>
        hideStatus?: boolean
        clearValuesOnClose?: boolean
        requireConfirm?: boolean
    }
}
